<template>
    <div class="question">
        <div class="inner">
            <span class="question-text">
                <slot name="question" />
            </span>
            <slot v-if="selected !== undefined" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        selected: Number,
    },
    computed: {
        game() {
            return this.$route.params.type;
        },
    },
};
</script>

<style lang="scss" scoped>
.question {
    position: relative;
    flex: 1;
    min-height: 50px;
    white-space: pre-line;
    color: #003a5d;
    font-weight: bold;
    z-index: 1;
    .question-text {
        padding: 10px 20px 0;
    }
    > .inner {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    @media screen and (max-width: 360px) {
        .question-text {
            padding: 10px 5px 0;
        }
    }
}
</style>
